import { Download, RefreshCw, WifiOff } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

import { usePwa } from './usePwa';

/**
 * Compact PWA affordances for the header: offline badge, install button and
 * update prompt. Only renders what is currently actionable.
 */
export function PwaStatus() {
  const { isOnline, isInstalled, canInstall, updateReady, install, applyUpdate } = usePwa();

  return (
    <div className="flex items-center gap-2">
      {!isOnline && (
        <Badge variant="destructive" className="gap-1">
          <WifiOff className="h-3 w-3" aria-hidden="true" />
          Offline
        </Badge>
      )}

      {updateReady && (
        <Button size="sm" variant="secondary" onClick={applyUpdate}>
          <RefreshCw aria-hidden="true" />
          Update laden
        </Button>
      )}

      {canInstall && !isInstalled && (
        <Button
          size="sm"
          variant="secondary"
          onClick={() => {
            void install();
          }}
        >
          <Download aria-hidden="true" />
          Installieren
        </Button>
      )}
    </div>
  );
}
